import React from 'react';
import { ActivityIcon, FlaskConicalIcon, HeartPulseIcon, LayersIcon, SearchCheckIcon, ShieldCheckIcon } from 'lucide-react';
import { SectionCta } from './SectionCta';
type Tomo = {
  number: string;
  title: string;
  description: string;
  Icon: typeof SearchCheckIcon;
  accent: string;
};
const TOMOS: Tomo[] = [{
  number: 'Tomo I',
  title: 'El método para diagnosticar sin equivocarse',
  description: 'Identifique quién realmente necesita una TRT y quién requiere otra estrategia antes de iniciar tratamiento.',
  Icon: SearchCheckIcon,
  accent: 'bg-navy-900'
}, {
  number: 'Tomo II',
  title: 'Domine la interpretación hormonal',
  description: 'Convierta perfiles complejos en decisiones claras usando el eje hormonal, SHBG, albúmina y testosterona libre.',
  Icon: FlaskConicalIcon,
  accent: 'bg-teal-800'
}, {
  number: 'Tomo III',
  title: 'La arquitectura de una TRT exitosa',
  description: 'Elija la formulación correcta, el mejor esquema terapéutico y personalice según el perfil de cada paciente.',
  Icon: LayersIcon,
  accent: 'bg-emerald-800'
}, {
  number: 'Tomo IV',
  title: 'Proteja la fertilidad y el equilibrio hormonal',
  description: 'Implemente correctamente hCG, SERMs y otras estrategias para preservar la fertilidad y reducir complicaciones.',
  Icon: ShieldCheckIcon,
  accent: 'bg-gold-600'
}, {
  number: 'Tomo V',
  title: 'Resuelva los casos que más desafían al médico',
  description: 'Obesidad, diabetes, síndrome metabólico, riesgo cardiovascular y otras condiciones especiales, con seguridad.',
  Icon: HeartPulseIcon,
  accent: 'bg-purple-800'
}, {
  number: 'Tomo VI',
  title: 'Controle la TRT como un experto',
  description: 'Monitorice el tratamiento, ajuste dosis en el momento adecuado y actúe rápido ante cualquier complicación.',
  Icon: ActivityIcon,
  accent: 'bg-sky-900'
}];
export function Tomos() {
  return <section className="w-full bg-cream-100 py-12 sm:py-16" aria-labelledby="tomos-title" data-id="element-227" data-mp="1zyzufd1qo2eg">
      <div className="mx-auto w-full max-w-3xl px-4" data-id="element-228" data-mp="1vyxzrnuf898o">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.16em] text-gold-600" data-id="element-229" data-mp="1w0969vf93v3h">
          Dentro del sistema
        </p>
        <h2 id="tomos-title" className="mt-3 text-center font-display text-[26px] font-bold leading-tight text-navy-900 sm:text-4xl" data-id="element-230" data-mp="24yb8ufemuvsv">
          6 tomos clínicos que cubren toda la ruta del paciente
        </h2>

        <div className="mt-7 grid grid-cols-1 gap-3.5 sm:grid-cols-2" data-id="element-231" data-mp="2ews4vqsfi0ls">
          {TOMOS.map(tomo => <article key={tomo.number} className="flex h-full flex-col rounded-2xl border border-navy-900/10 bg-white p-4 shadow-[0_10px_26px_-20px_rgba(11,32,56,0.6)]" data-id="element-232" data-mp="2snnljp965lzx">
              <div className="flex items-center gap-3" data-id="element-233" data-mp="32k8n20lzcez0">
                <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${tomo.accent}`} data-id="element-234" data-mp="2xotcbhj9qz6t">
                  <tomo.Icon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-235" data-mp="3lawye7qkh2sf" />
                </span>
                <span className="text-[11px] font-extrabold uppercase tracking-[0.14em] text-gold-600" data-id="element-236" data-mp="37b4bkni5v6pq">
                  {tomo.number}
                </span>
              </div>
              <h3 className="mt-3 font-display text-[18px] font-bold leading-snug text-navy-900 sm:text-xl" data-id="element-237" data-mp="3ccbikkchc1vc">
                {tomo.title}
              </h3>
              <p className="mt-2 text-[14px] leading-relaxed text-navy-800/75" data-id="element-238" data-mp="32d2sw3ond9es">
                {tomo.description}
              </p>
            </article>)}
        </div>

        <SectionCta label="Quiero los 6 tomos completos hoy" data-id="element-239" data-mp="2tj7pb036br19" />
      </div>
    </section>;
}